"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useCoercion = exports.CoercionContextProvider = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-float"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var CoercionContext = /*#__PURE__*/_react.default.createContext();

var CoercionContextProvider = function CoercionContextProvider(_ref) {
  var children = _ref.children;

  var _React$useState = _react.default.useState({}),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      coercions = _React$useState2[0],
      setCoercions = _React$useState2[1];

  return /*#__PURE__*/_react.default.createElement(CoercionContext.Provider, {
    value: {
      coercions: coercions,
      setCoercions: setCoercions
    }
  }, children);
};

exports.CoercionContextProvider = CoercionContextProvider;
var COERCION_FUNCTIONS = {
  Boolean: function Boolean(value) {
    return !!value;
  },
  Float: function Float(value) {
    return (0, _parseFloat2.default)(value);
  },
  Int: function Int(value) {
    return (0, _parseInt2.default)(value, 10);
  },
  Json: function Json(value) {
    return JSON.parse(value);
  }
};
var inputTypeToDataTypeMapping = {
  checkbox: 'Boolean',
  number: 'Int'
};

var useCoercion = function useCoercion() {
  var coercionContext = _react.default.useContext(CoercionContext);

  var coerce = _react.default.useCallback(function (name, value) {
    return coercionContext.coercions[name] ? coercionContext.coercions[name](value) : value;
  }, [coercionContext.coercions]);

  var setCoercion = _react.default.useCallback(function (_ref2) {
    var name = _ref2.name,
        type = _ref2.type,
        dataType = _ref2.dataType;

    var coercionFunction = COERCION_FUNCTIONS[dataType || inputTypeToDataTypeMapping[type]] || function (value) {
      return value;
    };

    coercionContext.setCoercions.call(null, function (coercions) {
      return (0, _objectSpread3.default)((0, _objectSpread3.default)({}, coercions), {}, (0, _defineProperty2.default)({}, name, coercionFunction));
    });
  }, [coercionContext.setCoercions]);

  return {
    coerce: coerce,
    setCoercion: setCoercion
  };
};

exports.useCoercion = useCoercion;